export const DEFAULT_OPACITY_TIMEOUT = 200;
